<template>
  <b-container>
    <h3>Challenges Albums</h3>
    <div class="d-flex justify-content-around">
      <multiselect label="albumName"
                    :options="albums"
                    placeholder="Pick album..."
                    :searchable="true"
                    track-by="id"
                    v-model="album"
                    @select="selectedAlbum">
      </multiselect>
    </div>
    <div class="m-2">
      <album-card :albumId="album.id"
                  v-if="album"
                  @update-selected-album="updateSelectedAlbum"
                  @delete-album-update="deleteAlbumUpdate">
      </album-card>
    </div>
  </b-container>
</template>

<script>
  const AlbumCard = () => import('./AlbumCard.vue');
  const Multiselect = () => import('vue-multiselect');
  import {  mapActions } from 'vuex';

  export default {
    name : 'AlbumList',
    data() {
      return {
        album  : null,
        albums : [],
      }
    },
    components : {
      AlbumCard,
      Multiselect,
    },
    methods : {
      ...mapActions({
        'getAlbumSongs'   : 'media/getChallengesAlbumSongs',
        'clearAlbumSongs' : 'media/clearChallengesAlbumSongs',
      }),

      /**
       * Get Album List
       */
      getAlbums() {
        this.$http.get('/api/challenges_albums', {
          params : {
            page    : 1,
            perPage : 500,
            sort    : '',
          },
        }).then(res => {
          this.albums = [];
          const alb = res.data.data;
          for (let i=0; i < alb.length; i++) {
            this.albums.push({
              id        : alb[i].item.challenges_album_id,
              albumName : alb[i].item.album_name,
            });
          }
        });
      },

      /**
       * Selected album
       *
       * @param data
       */
      selectedAlbum(data) {
        this.album = data;
        this.clearAlbumSongs();
        this.getAlbumSongs(data.id);
      },

      /**
       * Update Selected Album Data
       *
       * @param album
       */
      updateSelectedAlbum(album) {
        this.getAlbums(); // update album list
        this.selectedAlbum(album);
        this.album = album;
        this.albumId = album.id;
      },

      /**
       * Update Album List after Update
       */
      deleteAlbumUpdate() {
        this.getAlbums();
        this.album = null;
      },
    },
    mounted() {
      this.getAlbums();
    },
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/scss/components/admin/challenges_music/album-list";
</style>